<template>
  <div class="doctor-info-detail">
    <div style="padding: 5px;background: #efeff4;">
      <div class="doctor-cell">
        <img :src="doctorDetail.photourl" class="icon" />
        <div class="info">
          <div style="margin-top:12px;">
            <span style="font-weight: bold;font-size:17px;">{{
              doctorDetail.appointDoctorName
            }}</span>
            <span
              style="margin-left:10px;color:white;font-size:13px;background-color: #108eee;border-radius: 2px;"
              >{{ doctorDetail.levelname }}</span
            >
          </div>
          <div style="margin-top:6px;font-size:15px">
            坐诊科室：{{ doctorDetail.appointOfficeName }}
          </div>
          <div
            style="height:16px;margin:6px 0 5px 0;overflow: hidden;color:#999;font-size:13px;"
          >
            {{ doctorDetail.intro }}
          </div>
        </div>
      </div>
    </div>
    <div class="doctor-info-detail-content" style="background: white;">
      {{ doctorDetail.intro }}
    </div>
    <ph-button
      v-show="!nobutton"
      @click="goToDoctorList"
      style="margin-top: 1rem;"
      >立即预约</ph-button
    >
  </div>
</template>

<script>
// import DoctorScheduleView from "../components/DoctorScheduleView";

export default {
  components: {
    // DoctorScheduleView
  },
  data() {
    return {
      doctorDetail: {},
      nobutton: false
    };
  },
  created() {
    const { doctorNo, doctorName, nobutton = false } = this.$route.query;
    this.nobutton = nobutton;
    this.$http
      .post(this.$api.APPOINTMENT_DOCTOR_DETAIL, {
        doctorNo: doctorNo,
        doctorName: doctorName
      })
      .then(res => {
        this.doctorDetail = res;
      });
  },
  methods: {
    goToDoctorList() {
      this.$router.push({
        name: "appointment-schedule-doctor",
        query: {
          id: this.doctorDetail.appointDoctorCode,
          ...this.doctorDetail
        }
      });
    }
  }
};
</script>
<style lang="less">
.doctor-info-detail {
  &-content {
    margin: 1rem;
  }
}
.doctor-cell {
  display: flex;
  height: 100px;
  margin: 15px 15px 0 15px;
  background-color: white;
  border-radius: 8px;
}
.icon {
  width: 60px;
  min-width: 60px;
  height: 60px;
  margin: 15px 15px 0 15px;
  border-radius: 30px;
}
</style>
